import Vue from 'vue';
import Router from 'vue-router';
import Home from './views/Home.vue';
// import {i18n} from './i18n/i18n';


Vue.use(Router);

export const router = new Router({
  mode: 'history',
  routes: [ 
  //   {
  //   path: '*',
  //   component: (resolve) => require(['./views/error404.vue'], resolve)

  // },
  {
      path: '/',
      name: 'home',
      component: Home,
      meta: {
        'title': 'menu.home'
      }
    },{
      path: '/home',
      component: () => import('./views/Home.vue'),
      meta: {
        'title':'menu.home'
      }
    },{
      path: '/login',
      component: () => import('./views/Login.vue'),
    }, {
      path: '/profile',
      name: 'profile',
      component: () => import('./views/Profile.vue')
    },{
      path: '/createFeedback/:id?',
      name: 'createFeedback',
      component: () => import('./views/customer/CreateFeedback.vue'),
      meta: {
        'title': 'menu.createFeedback'
      }
    },{
      path: '/feedbackList',
      name: 'feedbackList',
      component: () => import('./views/customer/FeedbackList.vue'),
      meta: {
        'title': 'menu.feedbackList'
      }
    },{
      path: '/createinstalledMachine/:id?',
      name: 'createinstalledMachine',
      component: () => import('./views/customer/CreateinstalledMachine.vue'),
      meta: {
        'title': 'menu.installedMachine'
      }
    },{
      path: '/installedMachineList',
      name: 'installedMachineList',
      component: () => import('./views/customer/InstalledMachineList.vue'),
      meta: {
        'title': 'menu.installedMachineList'
      }
    },{
      path: '/installedSwFwList',
      name: 'installedSwFwList',
      component: () => import('./views/customer/InstalledSwFwList.vue'),
      meta: {
        'title': 'menu.installedSwFwList',
        'parent':'menu.installedList'
      }
    },{
      path: '/productList',
      name: 'productList',
      component: () => import('./views/customer/ProductList.vue'),
      meta: {
        'title': 'menu.productList'
      }
    },{
      path: '/accountManagement',
      name: 'accountManagement',
      component: () => import('./views/customer/AccountManagement.vue'),
      meta: {
        'title': 'menu.accountManagement'
      }
    },{
      path: '/customerManagement',
      name: 'customerManagement',
      component: () => import('./views/cusotmerManage/CustomerManagement.vue'),
      meta: {
        'title': 'menu.customerManagement',
        'parent': 'menu.customer',
      }
    },{
      path: '/customerFeedbackHandling',
      name: 'customerFeedbackHandling',
      component: () => import('./views/cusotmerManage/CustomerFeedbackHandling.vue'),
      meta: {
        'title': 'menu.customerFeedbackHandling',   
        'parent':'menu.customer',  
      }
    },{
      path: '/editCustomer/:id?',
      name: 'editCustomer',
      component: () => import('./views/cusotmerManage/EditCustomer.vue'),
      props: true,
      meta: {
        'title': 'menu.editCustomer',   
        'parent':'menu.customerManagement',  
        'parentPath': '/customerManagement',
      }
    },{
      path: '/processFeedback/:id?',
      name: 'processFeedback',
      component: () => import('./views/cusotmerManage/ProcessFeedback.vue'),
      props: true,
      meta: {
        'title': 'menu.editCustomerFeedback',   
        'parent':'menu.customerFeedbackHandling',  
        'parentPath': '/customerFeedbackHandling',
      }
    },
    // {
    //   path: '/viewFeedback/:id?',
    //   name: 'viewFeedback', 
    //   component: () => import('./views/components/customerManage/ViewFeedback.vue'),
    //   props: true,
    //   meta: {
    //     'title': 'menu.customerFeedbackHandling'        
    //   }
    // },
    {
      path: '/productandHardwareMapping',
      name: 'productandHardwareMapping',
      component: () => import('./views/swfw/ProductandHardwareMapping.vue'),
      meta: {
        'title': 'menu.productandHardwareMapping',
        'parent':'menu.swFwManagement'
      }
    },{
      path: '/firmwareVersionMapping',
      name: 'firmwareVersionMapping',
      component: () => import('./views/swfw/FirmwareVersionMapping.vue'),
      meta: {
        'title': 'menu.firmwareVersionMapping',
        'parent':'menu.swFwManagement'
      }
    },{
      path: '/dongleSerialNumber',
      name: 'dongleSerialNumber',
      component: () => import('./views/ps/DongleSerialNumber.vue'),
      meta: {
        'title': 'menu.dongleActiveCode',
        'parent':'menu.productShipping'
      }
    },{
      path: '/shippingData',
      name: 'shippingData',
      component: () => import('./views/ps/ShippingData.vue'),
      meta: {
        'title': 'menu.shippingData',
        'parent':'menu.productShipping'
      }
    },{
      path: '/searchCR',
      name: 'searchCR',
      component: () => import('./views/swfw/SearchCR.vue'),
      meta: {
        'title': 'menu.searchCR',
        'parent':'menu.swFwManagement'
      }
    },
    {
      path: '/searchCNC',
      name: 'searchCNC',
      component: () => import('./views/swfw/SearchCNC.vue'),
      meta: {
        'title': 'menu.searchCNC',
        'parent':'menu.swFwManagement'
      }
    },
    {
      path: '/createCR/:id?',
      name: 'createCR',
      component: () => import('./views/swfw/CreateCR.vue'),
      meta: {
        'title': 'menu.createCR',
        'parent':'menu.swFwManagement'
      }
    },
    {
      path: '/createCNC/:id?',
      name: 'createCNC',
      component: () => import('./views/swfw/CreateCNC.vue'),
      meta: {
        'title': 'menu.createCNC',
        'parent':'menu.swFwManagement'
      }
    },
    {
      path: '/softwareVersion',
      name: 'softwareVersion',
      component: () => import('./views/swfw/SoftwareVersion.vue'),
      meta: {
        'title': 'menu.softwareVersion',
        'parent':'menu.swFwManagement'
      }
    },
    {
      path: '/documentVersion',
      name: 'documentVersion',
      component: () => import('./views/swfw/DocumentVersion.vue'),
      meta: {
        'title': 'menu.documentVersion',
        'parent':'menu.swFwManagement'
      }
    },
    {
      path: '/sysValueManagement',
      name: 'sysValueManagement',
      component: () => import('./views/management/SysValueManagement.vue'),
      meta: {
        'title': 'menu.sysValueManagement',
        'parent':'menu.management'
      }
    },
    {
      path: '/sysValueDetailManagagement',
      name: 'sysValueDetailManagagement',
      component: () => import('./views/management/SysValueDetailManagagement.vue'),
      meta: {
        'title': 'menu.sysValueDetailManagagement',
        'parent':'menu.management'
      }
    },
    {
      path: '/announcementMaintain',
      name: 'announcementMaintain',
      component: () => import('./views/management/announcementMaintain.vue'),
      meta: {
        'title': 'menu.announcementMaintain',
        'parent':'menu.management'
      }
    },
    {
      path: '/faqMaintain',
      name: 'faqMaintain',
      component: () => import('./views/management/faqMaintain.vue'),
      meta: {
        'title': 'menu.announcementMaintain',
        'parent':'menu.management'
      }
    },
    {
      path: '/downloadLog',
      name: 'downloadLog',
      component: () => import('./views/management/DownloadLog.vue'),
      meta: {
        'title': 'menu.downloadLog',
        'parent':'menu.management'
      }
    },
    {
      path: '/feedbackStatByCaseType',
      name: 'feedbackStatByCaseType',
      component: () => import('./views/report/FeedbackStatByCaseType.vue'),
      meta: {
        'title': 'menu.feedbackStatByCaseType',
        'parent':'menu.report'
      }
    },{
      path: '/StatTarget',
      name: 'statTarget',
      component: () => import('./views/report/StatTarget.vue'),
      meta: {
        'title': 'menu.statTarget',
        'parent':'menu.report'
      }
    },{
      path: '/feedbackStatByFailureType',
      name: 'feedbackStatByFailureType',
      component: () => import('./views/report/FeedbackStatByFailureType.vue'),
      meta: {
        'title': 'menu.feedbackStatByFailureType',
        'parent':'menu.report'
      }
    },{
      path: '/feedbackStatByFailureTypeWithRma',
      name: 'feedbackStatByFailureTypeWithRma',
      component: () => import('./views/report/FeedbackStatByFailureTypeWithRma.vue'),
      meta: {
        'title': 'menu.feedbackStatByFailureTypeWithRma',
        'parent':'menu.report'
      }
    },{
      path: '/yieldStatByModel',
      name: 'yieldStatByModel',
      component: () => import('./views/report/YieldStatByModel.vue'),
      meta: {
        'title': 'menu.yieldStatByModel',
        'parent':'menu.report'
      }
    },{
      path: '/feedbackStatByHardware',
      name: 'feedbackStatByHardware',
      component: () => import('./views/report/FeedbackStatByHardware.vue'),
      meta: {
        'title': 'menu.feedbackStatByHardware',
        'parent':'menu.report'
      }
    },{
      path: '/rmaHandling',
      name: 'rmaHandling',
      component: () => import('./views/cusotmerManage/RmaHandling.vue'),
      meta: {
        'title': 'menu.rmaHandling',
        'parent': 'menu.customer',
      }
    },{
      path: '/rmaHandlingCust',
      name: 'rmaHandling',
      component: () => import('./views/customer/RmaHandlingCust.vue'),
      meta: {
        'title': 'menu.rmaHandling'
      }
    },{
      path: '/training',
      name: 'trainingFae',
      component: () => import('./views/cusotmerManage/TrainingFae.vue'),
      meta: {
        'title': 'menu.trainingFae',
        'parent': 'menu.customer',
      }
    },{
      path: '/trainingCust',
      name: 'trainingCust',
      component: () => import('./views/customer/TrainingCust.vue'),
      meta: {
        'title': 'menu.trainingCust'
      }
    }

  ]
});

const originalPush = router.push
router.push = function push(location, onResolve, onReject) {  
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
    return originalPush.call(this, location).catch(err => err)
}
